import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { Tag } from "@typings/Cue";
import { cn } from "@util/helpers";

type ArticleTagsProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The list of article tags. */
  tags?: Tag[];
  /** The additional link params to be added. */
  linkParams?: URLSearchParams;
};

/** This list the article tags. */
const ArticleTags = ({
  className,
  tags = [],
  linkParams,
}: ArticleTagsProps): React.ReactElement => {
  if (tags.length === 0) return <></>;

  return (
    <div
      data-testid="article-tags-component"
      className={cn("flex flex-wrap gap-4", className)}
    >
      {tags.map(({ id, urlPath, name }) => {
        const params = linkParams ? `?${linkParams?.toString()}` : "";

        return (
          <ButtonFactory
            key={id}
            buttonType={ButtonType.Link}
            link={`${urlPath}${params}`}
            text={name}
            className="whitespace-normal break-all rounded-full bg-gray-250 p-3 font-poppins text-2xs font-semibold leading-none tracking-2% text-gray-850 !no-underline hover:bg-gray-250"
          />
        );
      })}
    </div>
  );
};

export default ArticleTags;
